/** Convert a 2D array into a CSV string
 */
import numeric from "./NumericFunction";
import {v4 as uuidV4} from "uuid";


const mySpecialString = "--------------------------------------";
const arrayToCsv = (data) => {
  return data.map(row => row
    .map(String)  // convert every value to String
    .map(v => v.replaceAll('"', '""'))  // escape double colons
    .map(v => `"${v}"`)  // quote it
    .join(',')  // comma-separated
  ).join('\r\n');  // rows starting on new lines
}

const stringifyObjectsOfArrayAndJoin = (data) => {

  const temp = data.map(v => {
    if (typeof (v) === 'object') return JSON.stringify(v);
    return v;
  })
  return temp.join(mySpecialString);
  // return data.toString();
}
const stringToArray = (str) => {
  const arr = str.split("------");
  return arr;
}
/** Download contents as a file
 * Source: https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
 */
const downloadBlob = (content, filename, contentType) => {
  // Create a blob
  let blob = new Blob([content], {type: contentType});
  let url = URL.createObjectURL(blob);

  // Create a link to download it
  let pom = document.createElement('a');
  pom.href = url;
  pom.setAttribute('download', filename);
  pom.click();
}
const encodeToAscii = (str) => {
  let newStr = '';
  for (let i = 0; i < str.length; i++) {
    let code = str.charCodeAt(i) + " ";
    newStr += code
  }

  return newStr;
}

const decodeFromAscii = (str) => {

  const array = str.split(" ");

  let decodeStr = '';
  for (let i = 0; i < array.length; i++) {
    let de = String.fromCharCode(array[i]);
    decodeStr += de
  }
  // decodeStr= decodeStr.replaceAll(" ","");
  decodeStr = decodeStr.replaceAll("\x00", "");
  return decodeStr;
}

const makeReadyToDownloadFile = (arrayObjects, fileName, suffix = "") => {
  let str = stringifyObjectsOfArrayAndJoin(arrayObjects);
  str = encodeToAscii(str);
  suffix && (fileName += "." + suffix)
  downloadBlob(str, fileName, 'text/csv;charset=utf-8;')
}


const makeReadyToTableConfigFromUpload = (text) => {
  let temp = decodeFromAscii(text)
  temp = temp.split(mySpecialString);
  // temp.forEach(v => {
  //   v = JSON.parse(v)

  // })
  const newArray = temp.map(v => JSON.parse(v))
  return newArray;


}

const removeComma = (input) => {
  if (!input) {
    return ""
  }
  if (typeof input === 'number') {
    input += ""
  }
  return input.replaceAll(",", "")
}
const nullToZero = (input) => (input === null ? 0 : input);
const copyToClipBoard = (txt) => {
  navigator.clipboard.writeText(txt)
}

const generateCaptchaCode = () => {
  // captcha
  let alphabets = "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz";
  let first = alphabets[Math.floor(Math.random() * alphabets.length)];
  let second = Math.floor(Math.random() * 10);
  let third = Math.floor(Math.random() * 10);
  let fourth = alphabets[Math.floor(Math.random() * alphabets.length)];
  let fifth = alphabets[Math.floor(Math.random() * alphabets.length)];
  let sixth = Math.floor(Math.random() * 10);
  return first.toString() + second.toString() + third.toString() + fourth.toString() + fifth.toString() + sixth.toString();
};


const hasBadCharacters = (inputText) => {
  const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  return format.test(inputText)
}

const replacePlusWithTwoZeros = (value) => {
  value = value.replace("+", "00")
  return value;
}
const replaceTimesWithThreeZeros = (value) => {
  value = value.replace("*", "000")
  return value;
}

const replacePlusAndTimesWithZeros = (value) => {
  value = replacePlusWithTwoZeros(value);
  value = replaceTimesWithThreeZeros(value);
  return value
}
const randomNumberGenerator = () => Math.random() * 10000000000

const addUniqId = (object) => {

  const temp = {...object};
  temp.uniqId = randomNumberGenerator();
  return temp;
}

const jalaliMonth = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];
const giveMonthByNumber = (string) => {

  if (isNaN(parseInt(string))) {
    return ""
  }

  return jalaliMonth[(parseInt(string) - 1)]
}

const fishIdChanger = (object) => {

  const newObject = {};
  for (let key in object) {
    if (key === "11") newObject.name = object[key]      // آقا/خانم
    if (key === "12") newObject.salary = object[key]      // حقوق ماه
    if (key === "13") newObject.accountNumber = object[key]     // شماره حساب
    if (key === "14") newObject.jobTitle = object[key]      // شغل
    if (key === "15") newObject.education = object[key]     // تحصیلات
    if (key === "16") newObject.daysOfWork = object[key]      // کارکرد
    if (key === "17") newObject.requestDate = object[key]     // تاریخ درخواست
    if (key === "18") newObject.startWorkDate = object[key]      // تاریخ شروع به کار
    if (key === "19") newObject.jobReward = object[key] // مزد شغل      // مزد شغل
    if (key === "20") newObject.workerBen = object[key]     // بن کارگری
    if (key === "21") newObject.workerHousing = object[key]      // حق مسکن
    if (key === "22") newObject.workerPost = object[key]      // حق پست
    if (key === "23") newObject.workerChild = object[key]     // حق اولاد
    if (key === "24") newObject.workerMission = object[key]      // حق ماموریت
    if (key === "25") newObject.overTime = object[key]      // اضافه کار
    if (key === "26") newObject.otherRewards = object[key]     // سایر پاداش ها
    if (key === "27") newObject.workerInsurance = object[key]     // حق بیمه سهم کارگر
    if (key === "28") newObject.workerTax = object[key]     // مالیات
    if (key === "29") newObject.workerVam = object[key]     // قسط وام
    if (key === "30") newObject.workerKosurat = object[key]     // سایر کسورات
    if (key === "31") newObject.helpful = object[key]     // مساعده
    if (key === "32") newObject.lifeInsurance = object[key]     // بیمه عمر و حوادث
    if (key === "33") newObject.workerOtherBime = object[key]     // بیمه مکمل درمان
    if (key === "34") newObject.workerInsuranceCEO = object[key]   // بیمه سهم کارفرما
    if (key === "35") newObject.sanavat = object[key] // سنوات
    if (key === "36") newObject.title = object[key] // عنوان فیش حقوقی
  }
  return newObject;
}
const fileToDataUri = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };
    reader.readAsDataURL(file);
  });


const removeParenthesesInNumber = (myString) => {
  if (myString[0] === '(' && myString[myString.length - 1] === ')') {
    myString = myString.replaceAll('(', '')
    myString = myString.replaceAll(')', '')
    myString = parseInt(myString)
    return isNaN(+myString) ? 0 : (-1 * (+myString))

  } else {
    return isNaN(+myString) ? 0 : (+myString)

  }
}
const dontLetAddSecondPeriod = (str) => {
  if (str.includes(".")) {
    const firstPeriodIndex = str.indexOf(".");
    const secondPeriodIndex = str.indexOf(".", firstPeriodIndex + 1);

    if (secondPeriodIndex !== -1) {
      str = str.substring(0, secondPeriodIndex) + str.substring(secondPeriodIndex + 1);
    }
  }

  return str;
};
const limitThreeCharsAfterFirstPeriod = (str) => {
  if (str.includes(".")) {
    const firstPeriodIndex = str.indexOf(".");
    const charsAfterFirstPeriod = str.substring(firstPeriodIndex + 1, firstPeriodIndex + 4);
    str = str.substring(0, firstPeriodIndex + 1) + charsAfterFirstPeriod;
  }

  return str;
};
const dotToZeroDot = (str) => str === "." ? "0." : str

const LimitDotAndThreeCharsAfterDot = (str) => {
  let newStr = str

  newStr = numeric.p2e(newStr)
  if (newStr === "" || newStr === "00") {
    newStr = "0"
  }

  // Remove leading zero if the input is '0X' or '00X'
  if (/^0\d+$/.test(newStr)) {
    newStr = parseInt(newStr, 10).toString(); // This removes the leading zero
  }

  newStr = dotToZeroDot(newStr)
  newStr = dontLetAddSecondPeriod(newStr)
  newStr = limitThreeCharsAfterFirstPeriod(newStr)

  return newStr
}


const convertTabulatorDataToJson = (cols, tableData) => {


  const jsonData = tableData.map((row) => {
    const rowData = {};
    cols?.forEach((column) => {
      const field = column.field;
      const title = column.title;
      const value = row[field];

      rowData[title+""] = value

    });

    return rowData;
  });


  return jsonData;
}

const addRowIdToTable = tbData=>{
  let tableData = [...tbData]
  tableData=tableData.map((v,index)=> {
    v.rowId = index + 1
    return v
  })
  return tableData
}

const addUniqIdToTable = tbData=>{
  let tableData = [...tbData]
  tableData=tableData.map((v,index)=> {
    v.uniqId = uuidV4()
    return v
  })
  return tableData
}
function allowEnglishCharsAndNumbers(input) {
  // Regular expression to match English characters only
  const englishCharsRegex =  /^[a-zA-Z0-9]*$/;
  return englishCharsRegex.test(input);
}


const SEMICOLON_STRING = 'SEMICOLON'
const SEMICOLON_SIGN = ';'
 const removeSemicolon = (str) => str.replaceAll(SEMICOLON_SIGN, SEMICOLON_STRING)
 const AddSemicolon = (str) => str.replaceAll(SEMICOLON_STRING, SEMICOLON_SIGN)

const AMPERSAN_STRING = 'AMPERSAN'
const AMPERSAN_SIGN = '&'
 const removeAmpersan = (str) => str.replaceAll(AMPERSAN_SIGN, AMPERSAN_STRING)
 const AddAmpersan = (str) => str.replaceAll(AMPERSAN_STRING, AMPERSAN_SIGN)
const removePlusSign = (str) => str.replaceAll('+', 'PLUS_SIGN')
const AddPlusSign = (str) => str.replaceAll('PLUS_SIGN', '+')

const formatEditorData = (valueForState)=>{
  valueForState = utilsFunction.AddAmpersan(valueForState)
  valueForState = utilsFunction.AddSemicolon(valueForState)
  valueForState = AddPlusSign(valueForState)

  return valueForState
}
const parseEditorData = (valueForState)=>{
  valueForState = utilsFunction.removeAmpersan(valueForState)
  valueForState = utilsFunction.removeSemicolon(valueForState)
  valueForState = removePlusSign(valueForState)
  return valueForState
}

// Helper function to convert Persian numerals to English numerals
const convertToEnglishNumerals = (persianDate) => {
  const persianToEnglish = {
    '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
    '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
  };
  return persianDate.split('').map(char => persianToEnglish[char] || char).join('');
};

const utilsFunction = {
  formatEditorData,
  parseEditorData,
  removeAmpersan,
  AddAmpersan,
  allowEnglishCharsAndNumbers,
  addUniqIdToTable,
  addRowIdToTable,
  convertTabulatorDataToJson,
  LimitDotAndThreeCharsAfterDot,
  limitThreeCharsAfterFirstPeriod,
  dontLetAddSecondPeriod,
  removeParenthesesInNumber,
  fileToDataUri,
  fishIdChanger,
  jalaliMonth,
  giveMonthByNumber,
  replacePlusAndTimesWithZeros,
  replaceTimesWithThreeZeros,
  replacePlusWithTwoZeros,
  downloadBlob,
  arrayToCsv,
  encodeToAscii,
  decodeFromAscii,
  stringToArray,
  makeReadyToDownloadFile,
  makeReadyToTableConfigFromUpload,
  removeComma,
  nullToZero,
  copyToClipBoard,
  generateCaptchaCode,
  hasBadCharacters,
  randomNumberGenerator,
  addUniqId,
  AddSemicolon,
  removeSemicolon,
  convertToEnglishNumerals,

}
export default utilsFunction;





